export type Language = 'ar' | 'en' | 'he';

export const translations = {
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      product: 'المنتج',
      ai: 'الذكاء الاصطناعي',
      features: 'الميزات',
      pricing: 'الأسعار',
      useCases: 'حالات الاستخدام',
      resources: 'المقالات',
      faq: 'الأسئلة الشائعة',
      contact: 'تواصل معنا',
      about: 'عن الشركة',
      startFree: 'ابدأ مجانًا',
      login: 'تسجيل الدخول',
      myAccount: 'حسابي',
    },
    // Hero Section
    hero: {
      title: 'فواتيرك ومصروفاتك وتقاريرك… في نظام واحد',
      subtitle: 'إدارة الفوترة والمصروفات بسهولة، مع ذكاء اصطناعي يقرأ إيصالات المصروفات بمجرد تصويرها.',
      ctaPrimary: 'ابدأ مجانًا',
      ctaSecondary: 'احجز عرضًا',
    },
    // AI Section
    ai: {
      title: 'صوّر الفاتورة… والذكاء الاصطناعي يسجل المصروف تلقائيًا',
      teaser: 'التقط صورة لإيصال… وسيتم تسجيل المصروف تلقائيًا',
      step1: 'تصوير الإيصال',
      step1Desc: 'التقط صورة واضحة للإيصال من هاتفك',
      step2: 'استخراج البيانات',
      step2Desc: 'يستخرج الذكاء الاصطناعي المتجر والتاريخ والإجمالي والضريبة',
      step3: 'تصنيف المصروف',
      step3Desc: 'يقترح النظام فئة المصروف تلقائيًا',
      step4: 'التقارير الفورية',
      step4Desc: 'يظهر المصروف في تقاريرك فورًا',
      accuracy: 'الدقة والأمان',
      accuracyDesc: 'نستخدم تقنيات حديثة لاستخراج البيانات مع التزامنا بأعلى معايير الأمان وحماية الخصوصية.',
      beforeAfter: 'قبل وبعد',
      before: 'قبل: إدخال يدوي مرهق للإيصالات',
      after: 'بعد: تصوير واستخراج تلقائي خلال ثوانٍ',
    },
    // Features
    features: {
      title: 'كل ما تحتاجه لإدارة أعمالك',
      invoicing: 'الفوترة',
      invoicingDesc: 'أنشئ فواتير احترافية في دقائق وأرسلها لعملائك',
      expenses: 'تتبع المصروفات',
      expensesDesc: 'سجّل مصروفاتك بسهولة ورتّبها حسب الفئات',
      clients: 'العملاء والمنتجات',
      clientsDesc: 'أدِر بيانات عملائك ومنتجاتك في مكان واحد',
      reports: 'التقارير والتحليلات',
      reportsDesc: 'احصل على رؤى واضحة عن أداء أعمالك',
      multiCurrency: 'متعدد العملات',
      multiCurrencyDesc: 'تعامل مع عملات متعددة بسهولة',
      export: 'تصدير البيانات',
      exportDesc: 'صدّر فواتيرك وتقاريرك بصيغة PDF أو Excel',
      team: 'الفريق والصلاحيات',
      teamDesc: 'أضف أعضاء فريقك وحدد صلاحيات كل منهم',
    },
    // Pricing
    pricing: {
      title: 'خطط تناسب كل الأعمال',
      subtitle: 'ابدأ مجانًا وتطوّر حسب احتياجاتك',
      starter: 'المبتدئ',
      starterPrice: 'مجاني',
      starterDesc: 'للمشاريع الصغيرة والأفراد',
      business: 'الأعمال',
      businessPrice: '$19/شهريًا',
      businessDesc: 'للشركات المتنامية',
      enterprise: 'المؤسسات',
      enterprisePrice: 'تواصل معنا',
      enterpriseDesc: 'للمؤسسات الكبيرة',
      popular: 'الأكثر شعبية',
      perMonth: '/شهريًا',
      viewDetails: 'عرض التفاصيل',
      contactSales: 'تواصل للمؤسسات',
      aiNote: 'ميزة مسح الإيصالات بالذكاء الاصطناعي متاحة كبند ضمن باقات محددة أو كإضافة',
      comparePlansTitle: 'مقارنة الباقات',
      addOnsTitle: 'إضافات وتمديدات',
      docPackTitle: 'حزم مستندات إضافية',
      companyPackTitle: 'حزم شركات إضافية',
      tokenPackTitle: 'حزم رموز تحليل المصروفات',
    },
    // Use Cases
    useCases: {
      title: 'حلول لكل نوع من الأعمال',
      smallBusiness: 'أصحاب المشاريع الصغيرة',
      smallBusinessDesc: 'وفّر وقتك وركّز على تنمية مشروعك',
      retail: 'المتاجر والخدمات',
      retailDesc: 'إدارة سهلة للفواتير والمصروفات اليومية',
      medium: 'الشركات المتوسطة',
      mediumDesc: 'تقارير متقدمة وإدارة فريق العمل',
      accountants: 'المحاسبين',
      accountantsDesc: 'أدوات احترافية لإدارة حسابات العملاء',
      problem: 'المشكلة',
      solution: 'الحل',
      benefit: 'الفائدة',
    },
    // Resources / Articles
    resources: {
      title: 'المقالات',
      subtitle: 'مقالات ونصائح عملية لتطوير أعمالك وتحسين إدارتك المالية',
      filters: {
        all: 'الكل',
        business: 'ريادة الأعمال',
        finance: 'المالية',
        productivity: 'الإنتاجية',
        technology: 'التكنولوجيا',
      },
      readMore: 'اقرأ المقال',
      minRead: 'دقائق قراءة',
      backToArticles: 'العودة للمقالات',
      comingSoonHint: 'نعمل على إضافة المزيد من المقالات قريبًا.',
    },
    // FAQ
    faq: {
      title: 'الأسئلة الشائعة',
      subtitle: 'إجابات على أكثر الأسئلة شيوعًا',
      q1: 'كيف أبدأ باستخدام THI Invoices؟',
      a1: 'سجّل حسابًا مجانيًا وابدأ بإنشاء فاتورتك الأولى في دقائق.',
      q2: 'هل يمكنني تجربة النظام مجانًا؟',
      a2: 'نعم، نوفر باقة مجانية تتيح لك تجربة الميزات الأساسية.',
      q3: 'كيف تعمل ميزة مسح الإيصالات؟',
      a3: 'التقط صورة للإيصال، وسيقوم الذكاء الاصطناعي باستخراج البيانات تلقائيًا.',
      q4: 'هل بياناتي آمنة؟',
      a4: 'نعم، نستخدم أعلى معايير الأمان والتشفير لحماية بياناتك.',
      q5: 'هل يدعم النظام عملات متعددة؟',
      a5: 'نعم، يدعم النظام العديد من العملات العالمية.',
      q6: 'كيف يمكنني تصدير بياناتي؟',
      a6: 'يمكنك تصدير الفواتير والتقارير بصيغة PDF أو Excel.',
      q7: 'هل يوجد تطبيق للهاتف؟',
      a7: 'النظام يعمل بشكل ممتاز على متصفحات الهواتف، ونعمل على تطبيق مخصص.',
      q8: 'كيف أتواصل مع الدعم؟',
      a8: 'يمكنك التواصل معنا عبر البريد الإلكتروني أو نموذج التواصل.',
      q9: 'هل يمكنني إلغاء اشتراكي؟',
      a9: 'نعم، يمكنك إلغاء أو تغيير اشتراكك في أي وقت.',
      q10: 'هل توفرون تكاملات مع أنظمة أخرى؟',
      a10: 'نعمل على توفير تكاملات مع منصات المحاسبة والدفع قريبًا.',
    },
    // Contact
    contact: {
      title: 'تواصل معنا',
      subtitle: 'نسعد بالإجابة على استفساراتك',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      company: 'الشركة',
      phone: 'الهاتف',
      message: 'الرسالة',
      send: 'إرسال',
      bookDemo: 'احجز عرضًا',
      info: 'معلومات التواصل',
    },
    // About
    about: {
      title: 'عن THI Invoices',
      subtitle: 'رؤيتنا وقيمنا',
      story: 'قصتنا',
      storyText: 'نؤمن بأن إدارة الفواتير والمصروفات يجب أن تكون بسيطة وفعّالة. لذلك بنينا THI Invoices ليكون الحل الأمثل للأعمال بكل أحجامها.',
      vision: 'رؤيتنا',
      visionText: 'مساعدة الأعمال على النمو من خلال أدوات مالية ذكية وسهلة الاستخدام.',
      values: 'قيمنا',
      value1: 'الدقة',
      value1Desc: 'نلتزم بأعلى معايير الدقة في كل ما نقدمه',
      value2: 'السهولة',
      value2Desc: 'نصمم حلولاً بسيطة تناسب الجميع',
      value3: 'النمو',
      value3Desc: 'نساعد عملاءنا على تحقيق أهدافهم المالية',
    },
    // Footer
    footer: {
      description: 'نظام متكامل لإدارة الفواتير والمصروفات',
      pages: 'الصفحات',
      legal: 'القانونية',
      privacy: 'سياسة الخصوصية',
      terms: 'الشروط والأحكام',
      contact: 'التواصل',
      rights: 'جميع الحقوق محفوظة',
    },
    // Social Proof
    socialProof: {
      businesses: 'شركة',
      invoices: 'فاتورة',
      saved: 'ساعة موفرة',
    },
    // Benefits
    benefits: {
      time: 'توفير الوقت',
      timeDesc: 'أتمتة المهام الروتينية وتوفير ساعات عمل أسبوعيًا',
      organize: 'تنظيم أفضل',
      organizeDesc: 'كل فواتيرك ومصروفاتك في مكان واحد منظم',
      insights: 'تقارير ذكية',
      insightsDesc: 'رؤى واضحة تساعدك على اتخاذ قرارات أفضل',
    },
    // Testimonials
    testimonials: {
      title: 'ماذا يقول عملاؤنا',
      t1: 'وفّر لي THI Invoices ساعات من العمل أسبوعيًا. أنصح به بشدة!',
      t1Author: 'أحمد محمد',
      t1Role: 'صاحب متجر إلكتروني',
      t2: 'ميزة مسح الإيصالات غيّرت طريقة تتبع مصروفاتي تمامًا.',
      t2Author: 'سارة خالد',
      t2Role: 'مستشارة أعمال',
      t3: 'التقارير الواضحة ساعدتني على فهم وضع أعمالي بشكل أفضل.',
      t3Author: 'محمد علي',
      t3Role: 'مدير شركة',
    },
    // CTA
    cta: {
      ready: 'جاهز للبدء؟',
      readyDesc: 'انضم لآلاف الشركات التي تدير أعمالها بسهولة مع THI Invoices',
    },
    // Product Page
    product: {
      title: 'ما هو THI Invoices؟',
      subtitle: 'نظام متكامل لإدارة الفوترة والمصروفات',
      whatIs: 'نظام سحابي يساعدك على إنشاء الفواتير وتتبع المصروفات وإدارة أعمالك بكفاءة.',
      forWhom: 'لمن؟',
      forWhomDesc: 'لأصحاب الأعمال والمحاسبين والشركات بكل أحجامها.',
      howHelps: 'كيف يساعدك؟',
      howHelpsDesc: 'يوفر أدوات سهلة لإنشاء الفواتير وتتبع المصروفات والحصول على تقارير واضحة.',
      journey: 'رحلة المستخدم',
      step1: 'إنشاء حساب',
      step1Desc: 'سجّل مجانًا في دقيقة واحدة',
      step2: 'إعداد البيانات',
      step2Desc: 'أضف بيانات شركتك وعملائك',
      step3: 'ابدأ العمل',
      step3Desc: 'أنشئ فواتيرك وتتبع مصروفاتك',
      integrations: 'التكاملات',
      integrationsDesc: 'نعمل على توفير تكاملات مع منصات المحاسبة والدفع والمزيد',
      comingSoon: 'قريبًا',
    },
    // Privacy & Terms
    privacy: {
      title: 'سياسة الخصوصية',
      lastUpdated: 'آخر تحديث',
    },
    terms: {
      title: 'الشروط والأحكام',
      lastUpdated: 'آخر تحديث',
    },
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      product: 'Product',
      ai: 'AI Receipts',
      features: 'Features',
      pricing: 'Pricing',
      useCases: 'Use Cases',
      resources: 'Articles',
      faq: 'FAQ',
      contact: 'Contact',
      about: 'About',
      startFree: 'Start Free',
      login: 'Login',
      myAccount: 'My account',
    },
    // Hero Section
    hero: {
      title: 'Invoices, expenses, and insights — in one place',
      subtitle: 'Manage invoicing and expenses effortlessly, with AI that reads expense receipts from a photo.',
      ctaPrimary: 'Start Free',
      ctaSecondary: 'Book a Demo',
    },
    // AI Section
    ai: {
      title: 'Snap a receipt — AI logs the expense automatically',
      teaser: 'Snap a receipt — AI logs it instantly',
      step1: 'Capture Receipt',
      step1Desc: 'Take a clear photo of your receipt',
      step2: 'Extract Data',
      step2Desc: 'AI extracts merchant, date, total, and tax',
      step3: 'Categorize',
      step3Desc: 'System suggests expense category automatically',
      step4: 'Instant Reports',
      step4Desc: 'Expense appears in your reports immediately',
      accuracy: 'Accuracy & Security',
      accuracyDesc: 'We use modern technology for data extraction while maintaining the highest security and privacy standards.',
      beforeAfter: 'Before & After',
      before: 'Before: Manual receipt entry is exhausting',
      after: 'After: Snap and extract automatically in seconds',
    },
    // Features
    features: {
      title: 'Everything you need to manage your business',
      invoicing: 'Invoicing',
      invoicingDesc: 'Create professional invoices in minutes and send them to clients',
      expenses: 'Expense Tracking',
      expensesDesc: 'Record expenses easily and organize by categories',
      clients: 'Clients & Products',
      clientsDesc: 'Manage client and product data in one place',
      reports: 'Reports & Analytics',
      reportsDesc: 'Get clear insights about your business performance',
      multiCurrency: 'Multi-Currency',
      multiCurrencyDesc: 'Handle multiple currencies with ease',
      export: 'Data Export',
      exportDesc: 'Export invoices and reports as PDF or Excel',
      team: 'Team & Roles',
      teamDesc: 'Add team members and define permissions',
    },
    // Pricing
    pricing: {
      title: 'Plans for every business',
      subtitle: 'Start free and scale as you grow',
      starter: 'Starter',
      starterPrice: 'Free',
      starterDesc: 'For small projects and individuals',
      business: 'Business',
      businessPrice: '$19/month',
      businessDesc: 'For growing companies',
      enterprise: 'Enterprise',
      enterprisePrice: 'Contact Us',
      enterpriseDesc: 'For large organizations',
      popular: 'Most Popular',
      perMonth: '/month',
      viewDetails: 'View Details',
      contactSales: 'Contact Sales',
      aiNote: 'AI Receipt Scanning is available within specific plans or as an add-on',
      comparePlansTitle: 'Compare Plans',
      addOnsTitle: 'Add-ons & extensions',
      docPackTitle: 'Extra document packs',
      companyPackTitle: 'Extra company slots',
      tokenPackTitle: 'Expense AI token packs',
    },
    // Use Cases
    useCases: {
      title: 'Solutions for every business type',
      smallBusiness: 'Small Business Owners',
      smallBusinessDesc: 'Save time and focus on growing your business',
      retail: 'Retail & Services',
      retailDesc: 'Easy management of daily invoices and expenses',
      medium: 'Medium Companies',
      mediumDesc: 'Advanced reports and team management',
      accountants: 'Accountants',
      accountantsDesc: 'Professional tools for client account management',
      problem: 'Problem',
      solution: 'Solution',
      benefit: 'Benefit',
    },
    // Resources / Articles
    resources: {
      title: 'Articles',
      subtitle: 'Practical articles and tips to grow your business and improve financial management',
      filters: {
        all: 'All',
        business: 'Business',
        finance: 'Finance',
        productivity: 'Productivity',
        technology: 'Technology',
      },
      readMore: 'Read Article',
      minRead: 'min read',
      backToArticles: 'Back to Articles',
      comingSoonHint: 'We are adding more articles soon.',
    },
    // FAQ
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Answers to the most common questions',
      q1: 'How do I get started with THI Invoices?',
      a1: 'Sign up for a free account and create your first invoice in minutes.',
      q2: 'Can I try the system for free?',
      a2: 'Yes, we offer a free plan that lets you try the basic features.',
      q3: 'How does receipt scanning work?',
      a3: 'Take a photo of your receipt, and AI will automatically extract the data.',
      q4: 'Is my data secure?',
      a4: 'Yes, we use the highest security and encryption standards to protect your data.',
      q5: 'Does the system support multiple currencies?',
      a5: 'Yes, the system supports many global currencies.',
      q6: 'How can I export my data?',
      a6: 'You can export invoices and reports as PDF or Excel.',
      q7: 'Is there a mobile app?',
      a7: 'The system works great on mobile browsers, and we\'re working on a dedicated app.',
      q8: 'How do I contact support?',
      a8: 'You can reach us via email or the contact form.',
      q9: 'Can I cancel my subscription?',
      a9: 'Yes, you can cancel or change your subscription anytime.',
      q10: 'Do you offer integrations with other systems?',
      a10: 'We\'re working on integrations with accounting and payment platforms soon.',
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'re happy to answer your questions',
      name: 'Name',
      email: 'Email',
      company: 'Company',
      phone: 'Phone',
      message: 'Message',
      send: 'Send',
      bookDemo: 'Book a Demo',
      info: 'Contact Information',
    },
    // About
    about: {
      title: 'About THI Invoices',
      subtitle: 'Our vision and values',
      story: 'Our Story',
      storyText: 'We believe invoice and expense management should be simple and effective. That\'s why we built THI Invoices as the ideal solution for businesses of all sizes.',
      vision: 'Our Vision',
      visionText: 'Helping businesses grow through smart, easy-to-use financial tools.',
      values: 'Our Values',
      value1: 'Accuracy',
      value1Desc: 'We commit to the highest accuracy standards in everything we deliver',
      value2: 'Simplicity',
      value2Desc: 'We design simple solutions that work for everyone',
      value3: 'Growth',
      value3Desc: 'We help our clients achieve their financial goals',
    },
    // Footer
    footer: {
      description: 'Complete system for invoice and expense management',
      pages: 'Pages',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      contact: 'Contact',
      rights: 'All rights reserved',
    },
    // Social Proof
    socialProof: {
      businesses: 'Businesses',
      invoices: 'Invoices',
      saved: 'Hours Saved',
    },
    // Benefits
    benefits: {
      time: 'Save Time',
      timeDesc: 'Automate routine tasks and save hours every week',
      organize: 'Better Organization',
      organizeDesc: 'All your invoices and expenses in one organized place',
      insights: 'Smart Reports',
      insightsDesc: 'Clear insights to help you make better decisions',
    },
    // Testimonials
    testimonials: {
      title: 'What our customers say',
      t1: 'THI Invoices saves me hours of work every week. Highly recommended!',
      t1Author: 'Ahmed Mohamed',
      t1Role: 'E-commerce Owner',
      t2: 'The receipt scanning feature completely changed how I track expenses.',
      t2Author: 'Sarah Khaled',
      t2Role: 'Business Consultant',
      t3: 'The clear reports helped me understand my business better.',
      t3Author: 'Mohamed Ali',
      t3Role: 'Company Manager',
    },
    // CTA
    cta: {
      ready: 'Ready to get started?',
      readyDesc: 'Join thousands of businesses managing their work easily with THI Invoices',
    },
    // Product Page
    product: {
      title: 'What is THI Invoices?',
      subtitle: 'Complete system for invoicing and expense management',
      whatIs: 'A cloud system that helps you create invoices, track expenses, and manage your business efficiently.',
      forWhom: 'For Whom?',
      forWhomDesc: 'For business owners, accountants, and companies of all sizes.',
      howHelps: 'How does it help?',
      howHelpsDesc: 'Provides easy tools for creating invoices, tracking expenses, and getting clear reports.',
      journey: 'User Journey',
      step1: 'Create Account',
      step1Desc: 'Sign up free in one minute',
      step2: 'Setup Data',
      step2Desc: 'Add your company and client info',
      step3: 'Start Working',
      step3Desc: 'Create invoices and track expenses',
      integrations: 'Integrations',
      integrationsDesc: 'We\'re working on integrations with accounting, payment platforms, and more',
      comingSoon: 'Coming Soon',
    },
    // Privacy & Terms
    privacy: {
      title: 'Privacy Policy',
      lastUpdated: 'Last Updated',
    },
    terms: {
      title: 'Terms of Service',
      lastUpdated: 'Last Updated',
    },
  },
  he: {
    // Navigation
    nav: {
      home: 'ראשי',
      product: 'מוצר',
      ai: 'AI קבלות',
      features: 'תכונות',
      pricing: 'מחירים',
      useCases: 'מקרי שימוש',
      resources: 'מאמרים',
      faq: 'שאלות נפוצות',
      contact: 'צור קשר',
      about: 'אודות',
      startFree: 'התחל בחינם',
      login: 'התחברות',
      myAccount: 'החשבון שלי',
    },
    // Hero Section
    hero: {
      title: 'חשבוניות, הוצאות ותובנות — במקום אחד',
      subtitle: 'ניהול חשבוניות והוצאות בקלות, עם AI שקורא קבלות מתמונה.',
      ctaPrimary: 'התחל בחינם',
      ctaSecondary: 'תאם דמו',
    },
    // AI Section
    ai: {
      title: 'מצלמים קבלה — וה-AI רושם הוצאה מיד',
      teaser: 'מצלמים קבלה — וה-AI רושם הוצאה מיד',
      step1: 'צילום קבלה',
      step1Desc: 'צלם תמונה ברורה של הקבלה',
      step2: 'חילוץ נתונים',
      step2Desc: 'ה-AI מחלץ חנות, תאריך, סכום ומע"מ',
      step3: 'סיווג הוצאה',
      step3Desc: 'המערכת מציעה קטגוריה אוטומטית',
      step4: 'דוחות מיידיים',
      step4Desc: 'ההוצאה מופיעה בדוחות מיד',
      accuracy: 'דיוק ואבטחה',
      accuracyDesc: 'אנו משתמשים בטכנולוגיה מתקדמת לחילוץ נתונים תוך שמירה על סטנדרטים גבוהים של אבטחה ופרטיות.',
      beforeAfter: 'לפני ואחרי',
      before: 'לפני: הזנת קבלות ידנית מתישה',
      after: 'אחרי: צילום וחילוץ אוטומטי בשניות',
    },
    // Features
    features: {
      title: 'כל מה שצריך לניהול העסק',
      invoicing: 'חשבוניות',
      invoicingDesc: 'צור חשבוניות מקצועיות בדקות ושלח ללקוחות',
      expenses: 'מעקב הוצאות',
      expensesDesc: 'רשום הוצאות בקלות ומיין לפי קטגוריות',
      clients: 'לקוחות ומוצרים',
      clientsDesc: 'נהל נתוני לקוחות ומוצרים במקום אחד',
      reports: 'דוחות וניתוחים',
      reportsDesc: 'קבל תובנות ברורות על ביצועי העסק',
      multiCurrency: 'ריבוי מטבעות',
      multiCurrencyDesc: 'טפל במטבעות מרובים בקלות',
      export: 'ייצוא נתונים',
      exportDesc: 'ייצא חשבוניות ודוחות כ-PDF או Excel',
      team: 'צוות והרשאות',
      teamDesc: 'הוסף חברי צוות והגדר הרשאות',
    },
    // Pricing
    pricing: {
      title: 'תוכניות לכל עסק',
      subtitle: 'התחל בחינם והתרחב לפי הצורך',
      starter: 'מתחיל',
      starterPrice: 'חינם',
      starterDesc: 'לפרויקטים קטנים ויחידים',
      business: 'עסקי',
      businessPrice: '$19/חודש',
      businessDesc: 'לחברות צומחות',
      enterprise: 'ארגוני',
      enterprisePrice: 'צור קשר',
      enterpriseDesc: 'לארגונים גדולים',
      popular: 'הכי פופולרי',
      perMonth: '/חודש',
      viewDetails: 'הצג פרטים',
      contactSales: 'צור קשר עם מכירות',
      aiNote: 'סריקת קבלות AI זמינה בתוכניות מסוימות או כתוסף',
      comparePlansTitle: 'השוואת תוכניות',
      addOnsTitle: 'תוספים והרחבות',
      docPackTitle: 'חבילות מסמכים נוספים',
      companyPackTitle: 'חבילות חברות נוספות',
      tokenPackTitle: 'חבילות טוקני ניתוח הוצאות',
    },
    // Use Cases
    useCases: {
      title: 'פתרונות לכל סוג עסק',
      smallBusiness: 'בעלי עסקים קטנים',
      smallBusinessDesc: 'חסוך זמן והתמקד בצמיחת העסק',
      retail: 'קמעונאות ושירותים',
      retailDesc: 'ניהול קל של חשבוניות והוצאות יומיות',
      medium: 'חברות בינוניות',
      mediumDesc: 'דוחות מתקדמים וניהול צוות',
      accountants: 'רואי חשבון',
      accountantsDesc: 'כלים מקצועיים לניהול חשבונות לקוחות',
      problem: 'בעיה',
      solution: 'פתרון',
      benefit: 'יתרון',
    },
    // Resources / Articles
    resources: {
      title: 'מאמרים',
      subtitle: 'מאמרים וטיפים מעשיים לפיתוח העסק שלך ושיפור הניהול הפיננסי',
      filters: {
        all: 'הכל',
        business: 'עסקים',
        finance: 'פיננסים',
        productivity: 'פרודוקטיביות',
        technology: 'טכנולוגיה',
      },
      readMore: 'קרא מאמר',
      minRead: 'דקות קריאה',
      backToArticles: 'חזרה למאמרים',
      comingSoonHint: 'נוסיף עוד מאמרים בקרוב.',
    },
    // FAQ
    faq: {
      title: 'שאלות נפוצות',
      subtitle: 'תשובות לשאלות הנפוצות ביותר',
      q1: 'איך מתחילים עם THI Invoices?',
      a1: 'הירשם לחשבון חינמי וצור את החשבונית הראשונה שלך בדקות.',
      q2: 'האם אפשר לנסות את המערכת בחינם?',
      a2: 'כן, אנחנו מציעים תוכנית חינמית שמאפשרת לנסות תכונות בסיסיות.',
      q3: 'איך עובדת סריקת הקבלות?',
      a3: 'צלם תמונה של הקבלה, וה-AI יחלץ את הנתונים אוטומטית.',
      q4: 'האם הנתונים שלי מאובטחים?',
      a4: 'כן, אנחנו משתמשים בסטנדרטים הגבוהים ביותר של אבטחה והצפנה.',
      q5: 'האם המערכת תומכת במטבעות מרובים?',
      a5: 'כן, המערכת תומכת במטבעות עולמיים רבים.',
      q6: 'איך אני מייצא את הנתונים שלי?',
      a6: 'אפשר לייצא חשבוניות ודוחות כ-PDF או Excel.',
      q7: 'יש אפליקציה לנייד?',
      a7: 'המערכת עובדת מצוין בדפדפני נייד, ואנחנו עובדים על אפליקציה ייעודית.',
      q8: 'איך יוצרים קשר עם התמיכה?',
      a8: 'אפשר לפנות אלינו באימייל או בטופס יצירת קשר.',
      q9: 'אפשר לבטל את המנוי?',
      a9: 'כן, אפשר לבטל או לשנות את המנוי בכל עת.',
      q10: 'יש אינטגרציות עם מערכות אחרות?',
      a10: 'אנחנו עובדים על אינטגרציות עם פלטפורמות הנהלת חשבונות ותשלומים בקרוב.',
    },
    // Contact
    contact: {
      title: 'צור קשר',
      subtitle: 'נשמח לענות על שאלותיך',
      name: 'שם',
      email: 'אימייל',
      company: 'חברה',
      phone: 'טלפון',
      message: 'הודעה',
      send: 'שלח',
      bookDemo: 'תאם דמו',
      info: 'פרטי התקשרות',
    },
    // About
    about: {
      title: 'אודות THI Invoices',
      subtitle: 'החזון והערכים שלנו',
      story: 'הסיפור שלנו',
      storyText: 'אנחנו מאמינים שניהול חשבוניות והוצאות צריך להיות פשוט ויעיל. לכן בנינו את THI Invoices כפתרון האידיאלי לעסקים בכל הגדלים.',
      vision: 'החזון שלנו',
      visionText: 'לעזור לעסקים לצמוח באמצעות כלים פיננסיים חכמים וקלים לשימוש.',
      values: 'הערכים שלנו',
      value1: 'דיוק',
      value1Desc: 'אנחנו מחויבים לסטנדרטים הגבוהים ביותר של דיוק',
      value2: 'פשטות',
      value2Desc: 'אנחנו מעצבים פתרונות פשוטים שעובדים לכולם',
      value3: 'צמיחה',
      value3Desc: 'אנחנו עוזרים ללקוחותינו להשיג את המטרות הפיננסיות שלהם',
    },
    // Footer
    footer: {
      description: 'מערכת מלאה לניהול חשבוניות והוצאות',
      pages: 'עמודים',
      legal: 'משפטי',
      privacy: 'מדיניות פרטיות',
      terms: 'תנאי שימוש',
      contact: 'יצירת קשר',
      rights: 'כל הזכויות שמורות',
    },
    // Social Proof
    socialProof: {
      businesses: 'עסקים',
      invoices: 'חשבוניות',
      saved: 'שעות שנחסכו',
    },
    // Benefits
    benefits: {
      time: 'חיסכון בזמן',
      timeDesc: 'אוטומציה של משימות שגרתיות וחיסכון של שעות בכל שבוע',
      organize: 'ארגון טוב יותר',
      organizeDesc: 'כל החשבוניות וההוצאות שלך במקום מאורגן אחד',
      insights: 'דוחות חכמים',
      insightsDesc: 'תובנות ברורות שעוזרות לקבל החלטות טובות יותר',
    },
    // Testimonials
    testimonials: {
      title: 'מה הלקוחות שלנו אומרים',
      t1: 'THI Invoices חוסך לי שעות עבודה כל שבוע. ממליץ בחום!',
      t1Author: 'אחמד מוחמד',
      t1Role: 'בעל חנות מקוונת',
      t2: 'תכונת סריקת הקבלות שינתה לחלוטין את הדרך שבה אני עוקב אחר הוצאות.',
      t2Author: 'שרה חאלד',
      t2Role: 'יועצת עסקית',
      t3: 'הדוחות הברורים עזרו לי להבין את העסק שלי טוב יותר.',
      t3Author: 'מוחמד עלי',
      t3Role: 'מנהל חברה',
    },
    // CTA
    cta: {
      ready: 'מוכן להתחיל?',
      readyDesc: 'הצטרף לאלפי עסקים שמנהלים את העבודה שלהם בקלות עם THI Invoices',
    },
    // Product Page
    product: {
      title: 'מה זה THI Invoices?',
      subtitle: 'מערכת מלאה לניהול חשבוניות והוצאות',
      whatIs: 'מערכת ענן שעוזרת לך ליצור חשבוניות, לעקוב אחר הוצאות ולנהל את העסק ביעילות.',
      forWhom: 'למי?',
      forWhomDesc: 'לבעלי עסקים, רואי חשבון וחברות בכל הגדלים.',
      howHelps: 'איך זה עוזר?',
      howHelpsDesc: 'מספק כלים קלים ליצירת חשבוניות, מעקב הוצאות וקבלת דוחות ברורים.',
      journey: 'מסע המשתמש',
      step1: 'יצירת חשבון',
      step1Desc: 'הירשם בחינם בדקה אחת',
      step2: 'הגדרת נתונים',
      step2Desc: 'הוסף את פרטי החברה והלקוחות שלך',
      step3: 'התחל לעבוד',
      step3Desc: 'צור חשבוניות ועקוב אחר הוצאות',
      integrations: 'אינטגרציות',
      integrationsDesc: 'אנחנו עובדים על אינטגרציות עם פלטפורמות הנהלת חשבונות, תשלומים ועוד',
      comingSoon: 'בקרוב',
    },
    // Privacy & Terms
    privacy: {
      title: 'מדיניות פרטיות',
      lastUpdated: 'עדכון אחרון',
    },
    terms: {
      title: 'תנאי שימוש',
      lastUpdated: 'עדכון אחרון',
    },
  },
};

export const getDirection = (lang: Language): 'rtl' | 'ltr' => {
  return lang === 'ar' || lang === 'he' ? 'rtl' : 'ltr';
};

export const getFontClass = (lang: Language): string => {
  switch (lang) {
    case 'ar':
      return 'font-cairo';
    case 'he':
      return 'font-heebo';
    default:
      return 'font-inter';
  }
};
